export default __webpack_public_path__ + "static/media/animation-arrow7.b8d8fb99.gif";